module.exports = __webpack_public_path__ + "img/C06TechArithmetic_ua.11e548af.webp";